import { render } from "./TheChat.vue?vue&type=template&id=777d0754&scoped=true"
import script from "./TheChat.vue?vue&type=script&lang=js"
export * from "./TheChat.vue?vue&type=script&lang=js"

import "./TheChat.vue?vue&type=style&index=0&id=777d0754&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@5.109.2_clean-css@5.3.3_c_e59ecb87855333ab161cabc1a794339b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-777d0754"]])

export default __exports__